import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Card,
  Form,
  Statistic,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Layout,
  Collapse,
  Select,
  DatePicker,
  Button,
  Modal,
  Tooltip,
  InputNumber,
  Space,
  Checkbox,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import {
  PlusOutlined,
  DeleteOutlined,
  FolderOpenOutlined,
  EditOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import dayjs from "dayjs";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import styles from "../../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";

const ModifyFixedDepositAccount = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isManualInterestEntry, setIsManualInterestEntry] = useState(false);

  const { Text, Title } = Typography;
  const isWithHoldTax = Form.useWatch("withHoldTax", useForm);
  const maturityInstruction = Form.useWatch("maturityInstructionId", useForm);
  const [templateProdDetail, setTemplateProdDetail] = useState({});
  const [editingCharge, setEditingCharge] = useState(null);

  // CHARGES FORM REQURED VARIABLES
  const [chargeTableCount, setChargeTableCount] = useState(0);
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [interestRateChartTableSource, setInterestRateChartTableSource] =
    useState([]);
  const [interestChartDate, setInterestChartDate] = useState(null);

  // ENDPOINT DECLARED VARIABLES
  const [productData, setProductData] = useState([]);
  const [fieldOfficerData, setFieldOfficerData] = useState([]);
  const [currencyData, setCurrencyData] = useState({});
  const [
    interestCompoundingPeriodTypeOptions,
    setInterestCompoundingPeriodTypeOptions,
  ] = useState([]);
  const [
    interestPostingPeriodTypeOptions,
    setInterestPostingPeriodTypeOptions,
  ] = useState([]);
  const [interestCalculationTypeOptions, setInterestCalculationTypeOptions] =
    useState([]);
  const [
    interestCalculationDaysInYearTypeOptions,
    setInterestCalculationDaysInYearTypeOptions,
  ] = useState([]);
  const [
    lockinPeriodFrequencyTypeOptions,
    setLockinPeriodFrequencyTypeOptions,
  ] = useState([]);
  const [periodFrequencyTypeOptions, setPeriodFrequencyTypeOptions] = useState(
    []
  );
  const [chargesOptions, setChargesOptions] = useState([]);
  const [maturityInstructionOptions, setMaturityInstructionOptions] = useState(
    []
  );
  const [savingsAccountOptions, setSavingsAccountOptions] = useState([]);
  const [savingsProductOptions, setSavingsProductOptions] = useState([]);
  const [isWithholdTaxValue, setIsWithholdTaxValue] = useState(null);

  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargeList, setChargeList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    customerInfo: null,
    customerAddressInfo: null,
  });

  useEffect(() => {
    getProductTemplate(state);
  }, []);

  const onChangeProduct = (productParam) => {
    getCustomerProductTemplate(templateProdDetail, productParam);
  };

  const getProductTemplate = (state) => {
    const params = {
      associations: "charges, linkedAccount",
      template: true,
    };

    const url = `${apiConfig.FixedDepositAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        setTemplateProdDetail(objList);
        let tempProducts = [];
        let tempFieldOfficer = [];
        let tempCurrency = objList?.currency;
        let tempInterestCompoundingPeriodTypeOptions = [];
        let tempInterestPostingPeriodTypeOptions = [];
        let tempInterestCalculationTypeOptions = [];
        let tempInterestCalculationDaysInYearTypeOptions = [];
        let tempLockinPeriodFrequencyTypeOptions = [];
        let tempPeriodFrequencyTypeOptions = [];
        let tempPreClosurePenalInterestOnTypeOptions = [];
        let tempTaxGroupOptions = [];
        let tempAssetOptions = [];
        let tempEquityOptions = [];
        let tempExpenseOptions = [];
        let tempIncomeOptions = [];
        let tempLiabilityOptions = [];
        let tempCharges = [];
        let tempFromDate = objList?.accountChart?.fromDate;
        let tempChargesOptions = [];
        let tempPenaltyOptions = [];
        let tempPaymentTypeOptions = [];
        let tempMaturityInstruction = [];
        let tempSavingsAccountOptions = [];
        let tempSavingsProductOptions = [];
        let tempInterestRateChart = [];

        // SHOW THE SAVED DATA
        useForm.setFieldsValue({
          productId: objList.depositProductId,
          fieldOfficerId:
            objList.fieldOfficerId === 0 || !objList.fieldOfficerId
              ? null
              : objList.fieldOfficerId,
          submittedOnDate: objList?.timeline
            ? dayjs(BOM.FormatArrayDate(objList?.timeline?.submittedOnDate))
            : objList?.timeline?.submittedOnDate,
          nominalAnnualInterestRate: objList?.nominalAnnualInterestRate,
          interestCompoundingPeriodType:
            objList?.interestCompoundingPeriodType?.id,
          interestPostingPeriodType: objList?.interestPostingPeriodType?.id,
          interestCalculationType: objList?.interestCalculationType?.id,
          interestCalculationDaysInYearType:
            objList?.interestCalculationDaysInYearType?.id,
          minRequiredOpeningBalance: objList?.minRequiredOpeningBalance,
          depositAmount: objList?.depositAmount,
          depositPeriod: objList?.depositPeriod,
          depositPeriodFrequencyId: objList?.depositPeriodFrequency?.id,
          lockinPeriodFrequency: objList?.lockinPeriodFrequency,
          lockinPeriodFrequencyType: objList?.lockinPeriodFrequencyType?.id,
          minDepositTerm: `${
            objList?.minDepositTerm ? objList?.minDepositTerm : ""
          } - ${
            objList?.minDepositTermType?.value
              ? objList?.minDepositTermType?.value
              : ""
          }`,
          inMultiplesOfDepositTerm: `${
            objList?.inMultiplesOfDepositTerm
              ? objList?.inMultiplesOfDepositTerm
              : ""
          } - ${
            objList?.inMultiplesOfDepositTermType?.value
              ? objList?.inMultiplesOfDepositTermType?.value
              : ""
          }`,
          maxDepositTerm: `${
            objList?.maxDepositTerm ? objList?.maxDepositTerm : ""
          } - ${
            objList?.maxDepositTermType?.value
              ? objList?.maxDepositTermType?.value
              : ""
          }`,
          linkAccountId: objList?.linkedAccount?.id,
          transferInterestToSavings: objList.transferInterestToSavings,
          transferToSavingsId: objList.transferToSavingsId,
          withHoldTax: objList?.withHoldTax,
          taxGroup: objList?.taxGroup?.name,
          lienAllowed: objList?.lienAllowed,
          maxAllowedLienLimit: objList?.maxAllowedLienLimit,
          enforceMinRequiredBalance: objList?.enforceMinRequiredBalance,
          minRequiredBalance: objList?.minRequiredBalance,
          withdrawalFeeForTransfers: objList?.withdrawalFeeForTransfers,
          maturityInstructionId: objList?.onAccountClosure?.id,
          isManualInterestEntry:
            objList?.accountChart?.enableManualInterestEntry,
        });

        objList?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.fieldOfficerOptions?.forEach((element) => {
          tempFieldOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
          tempInterestCompoundingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestPostingPeriodTypeOptions?.forEach((element) => {
          tempInterestPostingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.interestCalculationTypeOptions?.forEach((element) => {
          tempInterestCalculationTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationDaysInYearTypeOptions?.forEach(
          (element) => {
            tempInterestCalculationDaysInYearTypeOptions.push({
              value: element.id,
              label: element.value,
            });
          }
        );
        objList?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
          tempLockinPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.periodFrequencyTypeOptions?.forEach((element) => {
          tempPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.preClosurePenalInterestOnTypeOptions?.forEach((element) => {
          tempPreClosurePenalInterestOnTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.accountChart?.chartSlabs?.forEach((element) => {
          tempInterestRateChart.push({
            periodType: element.periodType?.value
              ? element.periodType?.value
              : "-",
            fromPeriodTo: `${element.fromPeriod ? element.fromPeriod : " "} - ${
              element.toPeriod ? element.toPeriod : " "
            }`,
            amountRange: element.amountRangeFrom
              ? element.amountRangeFrom?.toLocaleString()
              : "-",
            interest: element.annualInterestRate
              ? element.annualInterestRate
              : "-",
            fromPeriod: element.fromPeriod,
            toPeriod: element.toPeriod,
            periodTypeId: element?.periodType?.id,
          });
        });

        objList?.taxGroupOptions?.forEach((element) => {
          tempTaxGroupOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.savingsAccounts?.forEach((element) => {
          tempSavingsProductOptions.push({
            value: element.id,
            label: `${element.accountNo}(${element.savingsProductName})`,
          });
        });

        objList?.savingsAccounts?.forEach((element) => {
          tempSavingsAccountOptions.push({
            value: element.id,
            label: `${element.accountNo}(${element.savingsProductName})`,
          });
        });

        objList?.maturityInstructionOptions?.forEach((element) => {
          tempMaturityInstruction.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.accountingMappingOptions?.assetAccountOptions?.forEach(
          (element) => {
            tempAssetOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.accountingMappingOptions?.equityAccountOptions?.forEach(
          (element) => {
            tempEquityOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.accountingMappingOptions?.expenseAccountOptions?.forEach(
          (element) => {
            tempExpenseOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.accountingMappingOptions?.incomeAccountOptions?.forEach(
          (element) => {
            tempIncomeOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.accountingMappingOptions?.liabilityAccountOptions?.forEach(
          (element) => {
            tempLiabilityOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        const chargesLength = objList?.charges?.length || 0;
        setChargeTableCount(chargesLength);

        objList?.charges?.forEach((element, index) => {
          tempCharges.push({
            key: index + 1,
            id: element?.id ? element?.id : "-",
            chargeId: element?.chargeId ? element?.chargeId : "-",
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              0
            ),
            amountToUse: element.amount ? element.amount : 0,
            collectedOn: element?.chargeTimeType?.value
              ? element?.chargeTimeType?.value
              : "-",
            feeOnMonthDay: element?.feeOnMonthDay
              ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
              : "-",

            feeInterval: element?.feeInterval?.value
              ? element?.feeInterval?.value
              : "-",
          });
        });

        objList?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objList?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setProductData(tempProducts);
        setInterestChartDate(tempFromDate);
        setSavingsAccountOptions(tempSavingsAccountOptions);
        setSavingsProductOptions(tempSavingsProductOptions);
        setMaturityInstructionOptions(tempMaturityInstruction);
        setFieldOfficerData(tempFieldOfficer);
        setCurrencyData(tempCurrency);
        setInterestCompoundingPeriodTypeOptions(
          tempInterestCompoundingPeriodTypeOptions
        );
        setInterestPostingPeriodTypeOptions(
          tempInterestPostingPeriodTypeOptions
        );
        setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
        setInterestCalculationDaysInYearTypeOptions(
          tempInterestCalculationDaysInYearTypeOptions
        );
        setLockinPeriodFrequencyTypeOptions(
          tempLockinPeriodFrequencyTypeOptions
        );
        setPeriodFrequencyTypeOptions(tempPeriodFrequencyTypeOptions);

        setChargeTableSource(tempCharges);
        setInterestRateChartTableSource(tempInterestRateChart);

        const chargeForTableData = tempChargesOptions.filter(
          (item) => item.currencyCode === tempCurrency.code
        );
        useForm.setFieldsValue({
          chargeId: "",
        });
        console.log(chargeForTableData);
        setChargesOptions([...chargeForTableData]);
        setIsWithholdTaxValue(objList.withHoldTax);
        setIsManualInterestEntry(
          objList?.accountChart?.enableManualInterestEntry
        );
        setIsLoading(false);
      }
    });
  };

  const getCustomerProductTemplate = (customerParam, productParam) => {
    const params = {
      clientId: customerParam.clientId,
      productId: productParam,
    };

    const url = `${apiConfig.savingsAccounts}/template`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempProducts = [];
        let tempFieldOfficer = [];
        let tempCurrency = objList?.currency;
        let tempInterestCompoundingPeriodTypeOptions = [];
        let tempInterestPostingPeriodTypeOptions = [];
        let tempInterestCalculationTypeOptions = [];
        let tempInterestCalculationDaysInYearTypeOptions = [];
        let tempLockinPeriodFrequencyTypeOptions = [];
        let tempPeriodFrequencyTypeOptions = [];
        let tempPreClosurePenalInterestOnTypeOptions = [];
        let tempTaxGroupOptions = [];
        let tempAssetOptions = [];
        let tempEquityOptions = [];
        let tempExpenseOptions = [];
        let tempIncomeOptions = [];
        let tempLiabilityOptions = [];
        let tempCharges = [];
        let tempChargesOptions = [];
        let tempPenaltyOptions = [];
        let tempPaymentTypeOptions = [];
        let tempMaturityInstruction = [];
        let tempSavingsAccountOptions = [];
        let tempSavingsProductOptions = [];

        useForm.setFieldsValue({
          submittedOnDate: objList?.timeline
            ? dayjs(BOM.FormatArrayDate(objList?.timeline?.submittedOnDate))
            : objList?.timeline?.submittedOnDate,
          nominalAnnualInterestRate: objList?.nominalAnnualInterestRate,
          interestCompoundingPeriodType:
            objList?.interestCompoundingPeriodType?.id,
          interestPostingPeriodType: objList?.interestPostingPeriodType?.id,
          interestCalculationType: objList?.interestCalculationType?.id,
          interestCalculationDaysInYearType:
            objList?.interestCalculationDaysInYearType?.id,
          minRequiredOpeningBalance: objList?.minRequiredOpeningBalance,
          lockinPeriodFrequency: objList?.lockinPeriodFrequency,
          lockinPeriodFrequencyType: objList?.lockinPeriodFrequencyType?.id,
          withHoldTax: objList?.withHoldTax,
          taxGroup: objList?.taxGroup?.name,
          lienAllowed: objList?.lienAllowed,
          maxAllowedLienLimit: objList?.maxAllowedLienLimit,
          enforceMinRequiredBalance: objList?.enforceMinRequiredBalance,
          minRequiredBalance: objList?.minRequiredBalance,
          withdrawalFeeForTransfers: objList?.withdrawalFeeForTransfers,
          maturityInstructionId: objList?.onAccountClosure?.id,
          isManualInterestEntry:
            objList?.accountChart?.enableManualInterestEntry,
        });

        objList?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.fieldOfficerOptions?.forEach((element) => {
          tempFieldOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
          tempInterestCompoundingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestPostingPeriodTypeOptions?.forEach((element) => {
          tempInterestPostingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationTypeOptions?.forEach((element) => {
          tempInterestCalculationTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.interestCalculationDaysInYearTypeOptions?.forEach(
          (element) => {
            tempInterestCalculationDaysInYearTypeOptions.push({
              value: element.id,
              label: element.value,
            });
          }
        );
        objList?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
          tempLockinPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.periodFrequencyTypeOptions?.forEach((element) => {
          tempPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.preClosurePenalInterestOnTypeOptions?.forEach((element) => {
          tempPreClosurePenalInterestOnTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objList?.taxGroupOptions?.forEach((element) => {
          tempTaxGroupOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.savingsAccounts?.forEach((element) => {
          tempSavingsProductOptions.push({
            value: element.id,
            label: element.savingsProductName,
          });
        });

        objList?.savingsAccounts?.forEach((element) => {
          tempSavingsAccountOptions.push({
            value: element.id,
            label: element.accountNo,
          });
        });

        objList?.maturityInstructionOptions?.forEach((element) => {
          tempMaturityInstruction.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.accountingMappingOptions?.assetAccountOptions?.forEach(
          (element) => {
            tempAssetOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.accountingMappingOptions?.equityAccountOptions?.forEach(
          (element) => {
            tempEquityOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.accountingMappingOptions?.expenseAccountOptions?.forEach(
          (element) => {
            tempExpenseOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.accountingMappingOptions?.incomeAccountOptions?.forEach(
          (element) => {
            tempIncomeOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.accountingMappingOptions?.liabilityAccountOptions?.forEach(
          (element) => {
            tempLiabilityOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objList?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        const chargesLength = objList?.charges?.length || 0;
        setChargeTableCount(chargesLength);

        objList?.charges?.forEach((element, index) => {
          tempCharges.push({
            key: index + 1,
            id: element?.id ? element?.id : "-",
            chargeId: element?.chargeId ? element?.chargeId : "-",
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              0
            ),
            amountToUse: element.amount ? element.amount : 0,
            collectedOn: element?.chargeTimeType?.value
              ? element?.chargeTimeType?.value
              : "-",
            feeOnMonthDay: element?.feeOnMonthDay
              ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
              : "-",

            feeInterval: element?.feeInterval?.value
              ? element?.feeInterval?.value
              : "-",
          });
        });

        objList?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objList?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setCurrencyData(tempCurrency);
        setInterestCompoundingPeriodTypeOptions(
          tempInterestCompoundingPeriodTypeOptions
        );
        setInterestPostingPeriodTypeOptions(
          tempInterestPostingPeriodTypeOptions
        );
        setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
        setInterestCalculationDaysInYearTypeOptions(
          tempInterestCalculationDaysInYearTypeOptions
        );
        setLockinPeriodFrequencyTypeOptions(
          tempLockinPeriodFrequencyTypeOptions
        );
        setChargeTableSource(tempCharges);

        const chargeForTableData = tempChargesOptions.filter(
          (item) => item.currencyCode === tempCurrency.code
        );
        useForm.setFieldsValue({
          chargeId: "",
        });
        setChargesOptions([...chargeForTableData]);
        setIsWithholdTaxValue(objList.withHoldTax);
        setIsManualInterestEntry(
          objList?.accountChart?.enableManualInterestEntry
        );
        setIsLoading(false);
      }
    });
  };

  function onCancel() {
    navigate("/detail-fixed-deposit-account", { state: state });
  }

  const handleChargeDelete = (key) => {
    console.log(key);
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = chargeTableSource.filter((item) => item.id !== key.id);
        setChargeTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    [
      {
        title: "Period Type",
        dataIndex: "periodType",
      },
      {
        title: "Period From / To",
        dataIndex: "fromPeriodTo",
      },
      {
        title: "Amount Range",
        dataIndex: "amountRange",
      },
      {
        title: "Interest",
        dataIndex: "interest",
      },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (_, record) =>
          interestRateChartTableSource.length >= 1 ? (
            <Tooltip title={`Incentives`}>
              <Button
                type="primary"
                icon={<FolderOpenOutlined />}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
              />
            </Tooltip>
          ) : null,
      },
    ],
    [
      {
        title: "Name",
        dataIndex: "name",
      },
      {
        title: "Type",
        dataIndex: "type",
      },
      {
        title: "Amount",
        dataIndex: "amount",
      },
      {
        title: "Collected On",
        dataIndex: "collectedOn",
      },
      {
        title: "Date",
        dataIndex: "feeOnMonthDay",
      },
      {
        title: "Repayments Every",
        dataIndex: "feeInterval",
      },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (_, record) =>
          chargeTableSource.length >= 1 ? (
            <Space>
              <Tooltip title="Edit Charge">
                <Button
                  type="default"
                  icon={<EditOutlined />}
                  shape="round"
                  size="small"
                  onClick={() => {
                    setEditingCharge(record);
                    setIsModalOpen(true);
                  }}
                  style={{ marginRight: 8 }}
                  className="of-primaryBtnColor"
                />
              </Tooltip>

              <Tooltip title={`Remove Charge`}>
                <Button
                  type="primary"
                  icon={<DeleteOutlined />}
                  onClick={() => handleChargeDelete(record)}
                  shape="round"
                  size="small"
                  className="of-primaryBtnColor"
                />
              </Tooltip>
            </Space>
          ) : null,
      },
    ],
  ];

  const onSubmit = (formValues) => {
    console.log(templateProdDetail);

    let tempChargeArray = [];

    chargeTableSource.forEach((element) => {
      const chargeObj = {
        chargeId: element.chargeId,
        amount: element.amountToUse,
      };

      if (element.feeOnMonthDay !== "-" && element.feeOnMonthDay) {
        const collectedOn = element.collectedOn?.toLowerCase().trim();

        if (collectedOn === "annual fee" || collectedOn === "monthly fee") {
          chargeObj.feeOnMonthDay = BOM.DateTimeWithoutYear(
            element.feeOnMonthDay,
            "only-date"
          );
        } else if (
          collectedOn === "weekly fee" ||
          collectedOn === "specified due date"
        ) {
          chargeObj.dueDate = BOM.DateTime(element.feeOnMonthDay, "only-date");
        } else {
          // fallback
          chargeObj.feeOnMonthDay = BOM.DateTimeWithoutYear(
            element.feeOnMonthDay,
            "only-date"
          );
        }
      }

      tempChargeArray.push(chargeObj);
    });

    let chartSlabs = [];
    interestRateChartTableSource.forEach((element, index) => {
      chartSlabs.push({
        c: element.amountRange,
        annualInterestRate: element.interest,
        fromPeriod: element.fromPeriod,
        incentives: [],
        locale: "en",
        periodType: element.periodTypeId,
        toPeriod: element.toPeriod,
      });
    });

    formValues.submittedOnDate = formValues.submittedOnDate
      ? BOM.DateTime(formValues.submittedOnDate, "only-date")
      : formValues.submittedOnDate;
    formValues.clientId = templateProdDetail.clientId;
    formValues.inMultiplesOfDepositTerm =
      templateProdDetail.inMultiplesOfDepositTerm;
    formValues.minDepositTerm = templateProdDetail.minDepositTerm;
    formValues.minDepositTermTypeId = templateProdDetail.minDepositTermType?.id;
    formValues.maxDepositTerm = templateProdDetail.maxDepositTerm;
    formValues.maxDepositTermTypeId = templateProdDetail.maxDepositTermType?.id;
    formValues.preClosurePenalApplicable =
      templateProdDetail.preClosurePenalApplicable;
    formValues.nominalAnnualInterestRate = formValues.nominalAnnualInterestRate
      ? formValues.nominalAnnualInterestRate
      : templateProdDetail.nominalAnnualInterestRate;
    formValues.charges = tempChargeArray;
    formValues.charts = [
      {
        fromDate: BOM.DateTime(interestChartDate, "only-date"),
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        isActiveChart: true,
        chartSlabs,
      },
    ];

    formValues.dateFormat = "dd MMMM yyyy";
    formValues.monthDayFormat = "dd MMMM";
    formValues.locale = "en";

    delete formValues.allowOverdraft;
    delete formValues.decimalPlaces;
    delete formValues.currencyName;
    delete formValues.inMultiplesOf;
    delete formValues.taxGroup;
    delete formValues.depositRollover;
    delete formValues.chargeId;

    const url = `${apiConfig.FixedDepositAccounts}/${state.id}`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.fixedDepositUpdateMsg);
          navigate("/detail-fixed-deposit-account", {
            state: { ...state, statusValue: accountStatus.submittedAndPending },
          });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          // navigate("/sms0100");
          navigate("/detail-fixed-deposit-account", {
            state: {
              ...state,
              statusValue: accountStatus.submittedAndPending,
            },
          });
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.editFixedDepositAccount}
        pageItems={[]}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              active: true,
              isPenalty: false,
            }}
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.fixedDepositAccSetUp}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.generalInfo}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.product}
                  name="productId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.product),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    // disabled
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.product,
                      "select"
                    )}
                    options={productData}
                    showSearch
                    onChange={onChangeProduct}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.staff} name="fieldOfficerId">
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.staff,
                      "select"
                    )}
                    options={fieldOfficerData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.currency}>
                  <Input
                    disabled
                    className="of-bold-disable-input"
                    value={`${currencyData.name ? currencyData.name : ""}${
                      currencyData.code ? ` (${currencyData.code})` : " - "
                    }`}
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.currency)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.decimalPlaces}>
                  <Input
                    disabled
                    className="of-bold-disable-input"
                    value={`${
                      currencyData.decimalPlaces
                        ? currencyData.decimalPlaces
                        : "-"
                    }`}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.decimalPlaces
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.currencyInMultiplesOf}>
                  <Input
                    disabled
                    className="of-bold-disable-input"
                    value={`${
                      currencyData.inMultiplesOf
                        ? currencyData.inMultiplesOf
                        : " - "
                    }`}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.currencyInMultiplesOf
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.submittedOn}
                  name="submittedOnDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.submittedOn),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={BOM.DisabledAfterCurrentDate}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.submittedDate,
                      "select"
                    )}
                    style={{ width: "100%", height: 35 }}
                  />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.interestInformation}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.interestCompoundingPeriod}
                  name="interestCompoundingPeriodType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.interestCompoundingPeriod
                      ),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.interestCompoundingPeriod,
                      "select"
                    )}
                    options={interestCompoundingPeriodTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.interestPostingPeriod}
                  name="interestPostingPeriodType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.interestPostingPeriod
                      ),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.interestPostingPeriod,
                      "select"
                    )}
                    options={interestPostingPeriodTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.interestCalculatedUsing}
                  name="interestCalculationType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.interestCalculatedUsing
                      ),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.interestCalculatedUsing,
                      "select"
                    )}
                    options={interestCalculationTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.depositAmount}
                  name="depositAmount"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.depositAmount),
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.depositAmount
                    )}
                    className="of-bold-disable-input"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.depositPeriod}
                  name="depositPeriod"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.depositPeriod),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.depositPeriod
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.depositPeriodType}
                  name="depositPeriodFrequencyId"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.depositPeriod,
                      "select"
                    )}
                    options={periodFrequencyTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.daysInYear}
                  name="interestCalculationDaysInYearType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.daysInYear),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.daysInYear,
                      "select"
                    )}
                    options={interestCalculationDaysInYearTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.lockInPeriod}
                  name="lockinPeriodFrequency"
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.lockInPeriod
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={" "} name="lockinPeriodFrequencyType">
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.lockInPeriod,
                      "select"
                    )}
                    options={lockinPeriodFrequencyTypeOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.depositInformation}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>{labelConfig.minimumDepositTerm}</Text>}
                  name="minDepositTerm"
                >
                  <Input disabled className="of-bold-disable-input" />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>{labelConfig.thereAferTerms}</Text>}
                  name="inMultiplesOfDepositTerm"
                >
                  <Input disabled className="of-bold-disable-input" />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>{labelConfig.maximumDepositTerm}</Text>}
                  name="maxDepositTerm"
                >
                  <Input disabled className="of-bold-disable-input" />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <Tooltip title={labelConfig.transferToAccount}>
                      {BOM.SubstringFormat(labelConfig.transferToAccount, 20)}
                    </Tooltip>
                  }
                  name="transferInterestToSavings"
                >
                  <Select
                    placeholder="Select Option"
                    options={staticConfig.statusData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>{labelConfig.linkAccount}</Text>}
                  name="linkAccountId"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder="Select one"
                    options={savingsProductOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>{labelConfig.maturityInstruction}</Text>}
                  name="maturityInstructionId"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder="Select one"
                    options={staticConfig.maturityInstructionData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              {maturityInstruction === 200 && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <Tooltip title={labelConfig.transferToAccount}>
                        {BOM.SubstringFormat(labelConfig.transferToAccount, 20)}
                      </Tooltip>
                    }
                    name="transferToSavingsId"
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder="Select one"
                      options={savingsAccountOptions}
                      showSearch
                    />
                  </Form.Item>
                </Col>
              )}
              {isWithholdTaxValue && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={<Text>{labelConfig.isWithholdTax}</Text>}
                      name="withHoldTax"
                    >
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(
                            input?.toLowerCase()
                          )
                        }
                        placeholder="Select one"
                        options={staticConfig.yesOrNoData}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                  {isWithHoldTax && (
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item
                        label={<Text>{labelConfig.taxGroup}</Text>}
                        name="taxGroup"
                      >
                        <Input disabled className="of-bold-disable-input" />
                      </Form.Item>
                    </Col>
                  )}
                </>
              )}
            </Row>
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.interestRateInfo}
              </Title>
            </Divider>
            {isManualInterestEntry && (
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item name="isManualInterestEntry" valuePropName="checked">
                  <Checkbox>{labelConfig.enableManualInterestEntry}</Checkbox>
                </Form.Item>
              </Col>
            )}

            <Form.Item noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const isManualEntry = getFieldValue("isManualInterestEntry");

                return isManualEntry ? (
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label="Interest Rate"
                      name="nominalAnnualInterestRate"
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Enter interest rate"
                        min={0}
                        max={100}
                        step={0.01}
                      />
                    </Form.Item>
                  </Col>
                ) : (
                  <Table
                    columns={columns[0]}
                    dataSource={interestRateChartTableSource}
                    bordered
                    pagination={{
                      position: "bottomCentre",
                      pageSize: "10",
                    }}
                  />
                );
              }}
            </Form.Item>

            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.chargeInfo}
              </Title>
            </Divider>
            <ChargeModal
              formData={formData}
              isModalOpen={isModalOpen}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setIsModalOpen={setIsModalOpen}
              chargeData={chargesOptions}
              setChargeList={setChargeList}
              setChargeTableSource={setChargeTableSource}
              chargeTableSource={chargeTableSource}
              chargeList={chargeList}
              session={session}
              editingCharge={editingCharge}
              setEditingCharge={setEditingCharge}
            />

            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {chargeTableSource.length > 1
                  ? labelConfig.selectedCharges
                  : labelConfig.selectedCharge}
              </Title>
            </Divider>

            {chargeTableSource?.length > 0 && (
              <Table
                columns={columns[1]}
                dataSource={chargeTableSource}
                bordered
                pagination={{
                  position: "bottomCentre",
                  pageSize: "10",
                }}
              />
            )}

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};
export default ModifyFixedDepositAccount;

const ChargeModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setChargeTableSource,
    chargeTableSource,
    isModalOpen,
    chargeData,
    setIsModalOpen,
    setChargeList,
    chargeList,
    editingCharge,
    setEditingCharge,
  } = props;

  const [useForm] = Form.useForm();

  useEffect(() => {
    if (editingCharge && isModalOpen) {
      const collected = editingCharge.collectedOn?.toLowerCase()?.trim();
      let dateValue = null;

      if (collected === "annual fee" || collected === "monthly fee") {
        if (editingCharge.feeOnMonthDayRaw) {
          dateValue = editingCharge.feeOnMonthDayRaw;
        } else if (Array.isArray(editingCharge.feeOnMonthDay)) {
          const [month, day] = editingCharge.feeOnMonthDay;
          dateValue = dayjs(new Date(dayjs().year(), month - 1, day));
        } else if (
          editingCharge.feeOnMonthDay &&
          editingCharge.feeOnMonthDay !== "-"
        ) {
          const parts = editingCharge.feeOnMonthDay.split(" ");
          if (parts.length === 2) {
            const [day, month] = parts;
            dateValue = dayjs(
              new Date(dayjs().year(), monthNameToIndex(month), day)
            );
          }
        }
      }

      if (collected === "weekly fee" || collected === "specified due date") {
        if (editingCharge.dueDateRaw) {
          dateValue = editingCharge.dueDateRaw;
        } else if (Array.isArray(editingCharge.dueDate)) {
          const [month, day] = editingCharge.dueDate;
          dateValue = dayjs(new Date(dayjs().year(), month - 1, day));
        } else if (editingCharge.dueDate) {
          dateValue = dayjs(editingCharge.dueDate, "DD MMM YYYY");
        }
      }

      useForm.setFieldsValue({
        chargeId: editingCharge.id,
        name: editingCharge.name,
        type: editingCharge.type,
        collectedOn: editingCharge.collectedOn,
        amount: editingCharge.amountToUse,
        feeOnMonthDay: dateValue,
        feeInterval:
          editingCharge.feeInterval !== "-" ? editingCharge.feeInterval : "",
      });
    } else {
      useForm.resetFields();
    }
  }, [editingCharge, isModalOpen]);

  const monthNameToIndex = (monthName) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months.indexOf(monthName);
  };
  const showModal = () => setIsModalOpen(true);

  const handleCancel = () => {
    setIsModalOpen(false);
    setEditingCharge(null);
    useForm.resetFields();
  };

  const disablePastDates = (current) => {
    return current && current < dayjs().startOf("day");
  };

  const handleChargeSave = (formValues) => {
    const collected = formValues.collectedOn?.toLowerCase()?.trim();
    let rawDate = formValues.feeOnMonthDay
      ? dayjs(formValues.feeOnMonthDay)
      : null;

    const newCharge = {
      key: formValues.chargeId,
      id: formValues.chargeId,
      chargeId: formValues.chargeId,
      name: formValues.name,
      type: formValues.type,
      collectedOn: formValues.collectedOn,
      amountToUse: formValues.amount,
      amount: (
        <Statistic
          value={formValues.amount}
          precision={2}
          valueStyle={{ fontSize: "16px" }}
        />
      ),
      feeInterval: formValues.feeInterval || "-",
    };

    if (rawDate) {
      if (collected === "annual fee" || collected === "monthly fee") {
        // store DD MMM for UI
        newCharge.feeOnMonthDay = rawDate.format("DD MMM");
        // keep full raw dayjs for re-edit
        newCharge.feeOnMonthDayRaw = rawDate;
      } else if (
        collected === "weekly fee" ||
        collected === "specified due date"
      ) {
        // displayed on table
        newCharge.feeOnMonthDay = rawDate.format("DD MMM YYYY");
        // keep for modal re-edit
        newCharge.dueDateRaw = rawDate;
        newCharge.dueDate = rawDate.format("DD MMM YYYY");
      } else {
        newCharge.feeOnMonthDay = rawDate.format("DD MMM");
        newCharge.feeOnMonthDayRaw = rawDate;
      }
    } else {
      newCharge.feeOnMonthDay = "-";
    }

    // update or add
    if (editingCharge) {
      setChargeTableSource((prev) =>
        prev.map((item) => (item.id === editingCharge.id ? newCharge : item))
      );
      setEditingCharge(null);
    } else {
      const found = chargeTableSource.find(
        (item) => item.chargeId === newCharge.chargeId
      );
      if (found) {
        BOM.AlertMsg(cnt.WARNING, labelConfig.noDuplicateCharges);
        return;
      }
      setChargeTableSource([...chargeTableSource, newCharge]);
    }

    useForm.resetFields();
    setIsModalOpen(false);
  };

  const handleSelectedCharge = (chargeId) => {
    const params = { template: "true" };
    const url = `${apiConfig.charges}/${chargeId}`;
    const body = { session, params };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, objList) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
        return;
      }

      let feeOnMonthDay = null;

      if (Array.isArray(objList.feeOnMonthDay)) {
        const [month, day] = objList.feeOnMonthDay;
        feeOnMonthDay = dayjs(new Date(dayjs().year(), month - 1, day));
      } else if (objList.feeOnMonthDay) {
        feeOnMonthDay = dayjs(objList.feeOnMonthDay, "DD MMM YYYY");
      }

      const collected = objList?.chargeTimeType?.value?.toLowerCase()?.trim();

      let dateValue = null;
      if (collected === "annual fee" || collected === "monthly fee") {
        dateValue = feeOnMonthDay;
      } else if (
        collected === "weekly fee" ||
        collected === "specified due date"
      ) {
        dateValue = feeOnMonthDay;
      }

      useForm.setFieldsValue({
        chargeId: objList.id,
        name: objList.name,
        type: objList.chargeCalculationType.value,
        collectedOn: objList.chargeTimeType.value,
        amount: objList.amount,
        feeOnMonthDay: dateValue || null,
        feeInterval: objList.feeInterval || "",
      });

      setIsLoading(false);
    });
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        {labelConfig.addCharge}
      </Button>

      <Modal
        open={isModalOpen}
        title={
          editingCharge ? "Edit Charge Information" : "Charge Information Setup"
        }
        okText={editingCharge ? "Save Changes" : "Add"}
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: { ...styles.ofPrimaryBtnColor },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleChargeSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="chargeId"
                label="Charge Options"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.charge),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.charge,
                    "select"
                  )}
                  options={chargeData}
                  onChange={handleSelectedCharge}
                  style={{ width: "30vh" }}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Divider />
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.name} name="name">
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.type} name="type">
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.type)}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.collectedOn} name="collectedOn">
                <Input
                  disabled
                  className="of-bold-disable-input"
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.collectedOn
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.amount} name="amount">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                />
              </Form.Item>
            </Col>

            {/* ✅ Date with full year support */}
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.date} name="feeOnMonthDay">
                <DatePicker
                  format="DD MMM YYYY"
                  disabledDate={disablePastDates}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.date,
                    "select"
                  )}
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.repaymentFrequency}
                name="feeInterval"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.repaymentFrequency
                  )}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
